import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { STORAGE_BUCKET_ORIGIN } from "../../../config/constants";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { BannerService } from "../../../services/banner-service";

export const Bannereditcontent = (props) => {
  const { bannerID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  var bodyFormData = new FormData();

  const [uploadedFile, setUploadedFile] = useState();

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);
    bodyFormData.append("type", values.type);
    bodyFormData.append("open_type", values.open_type);
    bodyFormData.append("url", values.url);
    bodyFormData.append("description", values.description);
    bodyFormData.append("status", values.status);
    bodyFormData.append("image", uploadedFile);

    try {
      await BannerService.bannerUpdate(bannerID, bodyFormData);

      setSubmitLoading(true);
      notify("Banner successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
        notifyWarning(err.response.data.message[0]);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    BannerSearchID();
  }, []);

  const [bannerinfo, setBannerInfo] = useState({
    type: "",
    open_type: "",
    url: "",
    description: "",
    image: "",
    status: "",
  });

  const BannerSearchID = async () => {
    try {
      const result = await BannerService.bannerDetailsID(bannerID);

      const info = {};

      const bannerdata = result;

      info.type = bannerdata.type;
      info.open_type = bannerdata.open_type;
      info.url = bannerdata.url;
      info.description = bannerdata.description;
      info.image = bannerdata.image;
      info.status = bannerdata.status;

      setBannerInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Banner</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  type: bannerinfo.type,
                  open_type: bannerinfo.open_type,
                  url: bannerinfo.url,
                  description: bannerinfo.description,
                  status: bannerinfo.status,
                  image: bannerinfo.image,
                }}
                validationSchema={Yup.object().shape({
                  type: Yup.string().required("Required"),
                  open_type: Yup.string().required("Required"),

                  url: Yup.string().required("Required"),

                  description: Yup.string().required("Required"),
                  // image: Yup.string().required("Please, select an image"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                  setFieldValue,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom15">Type</label>
                        <div className="input-group">
                          <select
                            name="type"
                            className="form-control"
                            id="selectstatus"
                            required
                            value={values.type}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="MAIN_BANNER">MAIN BANNER</option>
                            <option value="SPECIAL_PROMO">SPECIAL PROMO</option>
                            <option value="SPECIAL_MENU">SPECIAL MENU</option>
                            <option value="SHORTCUT">SHORTCUT</option>
                            <option value="ON_PAGE_LOAD">ON PAGE LOAD</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.type && errors.type}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom15">Open Type</label>
                        <div className="input-group">
                          <select
                            name="open_type"
                            className="form-control"
                            id="selectstatus"
                            required
                            value={values.open_type}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="NONE">NONE</option>
                            <option value="POPUP">POPUP</option>
                            <option value="URL">URL</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.open_type && errors.open_type}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">URL</label>
                        <div className="input-group">
                          <input
                            name="url"
                            type="text"
                            className="form-control"
                            id="urlID"
                            placeholder="URL"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.url}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.url && errors.url}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Description</label>
                        <div className="input-group">
                          <input
                            name="description"
                            type="text"
                            className="form-control"
                            id="descriptionID"
                            placeholder="DESCRIPTION"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.description && errors.description}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom15">
                          Change Status
                        </label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="selectstatus"
                            required
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="DISABLED">DISABLED</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.status && errors.status}
                        </div>
                      </div>
                    </div>

                    <label htmlFor="validationCustom08">Upload Image</label>
                    <div>
                      <img
                        alt=""
                        src={
                          uploadedFile != null
                            ? URL.createObjectURL(uploadedFile)
                            : `${STORAGE_BUCKET_ORIGIN}${bannerinfo.image}`
                        }
                        style={{ height: "100px" }}
                      />
                    </div>
                    <div className="input-group mt-2">
                      <input
                        id="maincatupload"
                        type="file"
                        name="image"
                        onBlur={handleBlur}
                        onChange={(event) => {
                          setUploadedFile(event.currentTarget.files[0]);
                          setFieldValue("image", "file");
                        }}
                      />

                      <div style={{ color: "red", fontSize: "12px" }}>
                        {touched.image && errors.image}
                      </div>
                    </div>
                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>

                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Save and Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bannereditcontent;
